import { Dataset } from './ChartInterface';

export const handleOther = (
  dataset: Dataset[],
  maxDisplay: number,
  total: number,
): Dataset[] => {
  const displayed = dataset.slice(0, maxDisplay);
  const remaining = dataset.slice(maxDisplay);
  if (remaining.length > 0) {
    displayed.push({
      name: 'Other',
      value: remaining.reduce((sum, value) => sum + value.value, 0),
      pourcent:
        (remaining.reduce((sum, value) => sum + value.value, 0) / total) * 100,
    });
  }
  return displayed;
};
